<div mat-dialog-title class="ds">
  <span>{{appStrings.quotes_search}}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
@if (loading) {
  <div class="loading">
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}
@if (!loading) {
  <div mat-dialog-content class="content ds" [ngClass]="{'mobile': isMobile}">
    <div class="quotes-search-container">
      <form [formGroup]="quotesSearchForm" (keyup.enter)="btnCallback(1)">
        <ds-date-picker id="startDate" [ngClass]="isMobile ? 'fill-width' : 'half-width'" [label]="appStrings.quotesStartDate"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="quotesSearchForm.controls.startDate"
          [date_format]="dsDateFormat"
        ></ds-date-picker>
        <ds-date-picker id="endDate" [ngClass]="isMobile ? 'fill-width' : 'half-width'" [label]="appStrings.quotesEndDate"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="quotesSearchForm.controls.endDate"
          [date_format]="dsDateFormat"
        ></ds-date-picker>
        <ds-textfield id="customerName" class="fill-width" [label]="appStrings.quoteSearch_customerName" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"
          [control]="quotesSearchForm.controls.customerName"
        ></ds-textfield>
        <ds-textfield id="bpNumber" class="fill-width" [label]="appStrings.quoteSearch_bpNumber" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"
          [control]="quotesSearchForm.controls.bpNumber"
        ></ds-textfield>
        <ds-textfield id="quoteName" class="fill-width" [label]="appStrings.quoteSearch_quoteName" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"
          [control]="quotesSearchForm.controls.quoteName"
        ></ds-textfield>
        <ds-textfield id="quoteNumber" class="fill-width" [label]="appStrings.quoteSearch_quoteNumber" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"
          placeholder="Ex. IMP-000011111" [control]="quotesSearchForm.controls.quoteNumber"
        ></ds-textfield>
        <ds-select id="confidenceToClose" class="fill-width" [label]="isMobile ? appStrings.lastTen_confToClosePct : appStrings.quoteSearch_confidencePct"
          [dropOptions]="confidenceToCloseDisplay" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="quotesSearchForm.controls.confidence"
        ></ds-select>
        <ds-textfield id="dollarAmount" [ngClass]="isMobile ? 'fill-width' : 'half-width fill-gap'" [start_adornment_type]="currency ? 'text' : null" [start_adornment_value_text]="currency"
          [label]="displayedTextAmount" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="quotesSearchForm.controls.dollarAmount"
        ></ds-textfield>
        <ds-textfield id="expiringInDays" [ngClass]="isMobile ? 'fill-width' : 'third-width'" [label]="appStrings.quoteSearch_expiringInDays"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="quotesSearchForm.controls.expiringInDays"
        ></ds-textfield>
        <ds-textfield id="dollarRangeMin" [ngClass]="isMobile ? 'fill-width' : 'half-width'" [start_adornment_type]="currency ? 'text' : null" [start_adornment_value_text]="currency"
          [label]="displayedTextAmountFrom" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="quotesSearchForm.controls.dollarRangeMin"
        ></ds-textfield>
        <ds-textfield id="dollarRangeMax" [ngClass]="isMobile ? 'fill-width' : 'half-width'" [start_adornment_type]="currency ? 'text' : null" [start_adornment_value_text]="currency"
          [label]="displayedTextAmountTo" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="quotesSearchForm.controls.dollarRangeMax"
        ></ds-textfield>
      </form>
    </div>
  </div>
}
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @for (button of buttons; track button; let i = $index) {
      <ds-button id="dialogButton_{{i}}" variant="label-only"  size="medium"
        [type]="button.type" (onClick)="btnCallback(i)" [label]="button.label" [isDisabled]="button.disableEmpty && disableButtons">
      </ds-button>
    }
  </div>
</div>
